export default "__VITE_ASSET__20b35407__"